import moment from "moment";
import type { IPageInfo } from "@/interface/common.interface";
import type { EmployeeCategory } from "@/interface/employeeOnBoard";

export const CATEGORY_OPTIONS: { label: string; value: EmployeeCategory }[] = [
  { label: "Select Your Category", value: "" as unknown as EmployeeCategory },
  { label: "Monthly-Salary", value: "Monthly-Salary" },
  { label: "Trainee", value: "Trainee" },
  { label: "Consultant", value: "Consultant" },
  { label: "Contract", value: "Contract" },
  { label: "Daily-Wage", value: "Daily-Wage" },
];

export const createInitialPageInfo = (): IPageInfo => ({
  currentPage: 1,
  pageSize: 10,
  total: 0,
  totalPages: 0,
});

export const getInitialSalaryCycleDates = () => {
  const today = moment();

  if (today.date() > 20) {
    return {
      startDate: today.clone().date(21).format("YYYY-MM-DD"),
      endDate: today.clone().add(1, "month").date(20).format("YYYY-MM-DD"),
    };
  }

  return {
    startDate: today.clone().subtract(1, "month").date(21).format("YYYY-MM-DD"),
    endDate: today.clone().date(20).format("YYYY-MM-DD"),
  };
};
